/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Box, Seg, Table } from "./widgets";
import { IN, formatLabel, fx, n0, nz, ovFromBalls, ballsFromOvers, seasonSeries, dash } from "./model";
import { useCareer } from "./OverviewPane";

const StatsPane = ({ overview }: { overview: any }) => {
  const { bat, bowl } = useCareer(overview);
  const [mode, setMode] = useState<"bat" | "bowl">("bat");
  const mini = nz<any>(overview?.tournamentMiniStats);
  const fmts = Array.from(new Set(bat.map((b) => b.format as string)));
  const [sf, setSf] = useState("all");
  const seasons = seasonSeries(mini, sf).filter((s) => s.m > 0).reverse();
  const comps = mini.filter((t) => n0(t.matchesPlayed) > 0);

  return (
    <>
      <Box title="Career by format" right={<Seg options={[["bat", "Batting"], ["bowl", "Bowling"]]} value={mode} onChange={setMode} />}>
        {mode === "bat" ? (
          <Table head={["Format", "M", "Inn", "NO", "Runs", "HS", "Avg", "SR", "50+", "100s", "50–99", "4s", "6s"]}
            rows={bat.map((x) => [formatLabel(x.format), x.matchesPlayed, x.inningsPlayed, x.notOuts, IN(n0(x.runsScored)), x.highestScore, fx(x.battingAverage), fx(x.strikeRate, 1), n0(x.hundreds) + n0(x.fifties), x.hundreds, x.fifties, x.fours, x.sixes])} />
        ) : (
          <Table head={["Format", "M", "Inn", "Overs", "Runs", "Wkts", "Avg", "Econ", "SR", "3W", "5W"]}
            rows={bowl.map((x) => [formatLabel(x.format), x.matchesPlayed, x.inningsPlayed, ovFromBalls(ballsFromOvers(x.oversBowled)), x.runsConceded, x.wicketsTaken, fx(x.bowlingAverage), fx(x.economyRate), fx(x.strikeRate, 1), x.threeWicketHauls, x.fiveWicketHauls])} />
        )}
        {mode === "bat" && <div className="box-f"><span>50+ counts every score of 50 or more, so it includes hundreds. 50–99 counts half-centuries only.</span></div>}
      </Box>
      <Box title="By season" sub="Matches, runs and wickets" right={fmts.length > 1 ? <Seg options={[["all", "All"], ...fmts.map((f) => [f, formatLabel(f)] as [string, string])] as any} value={sf} onChange={setSf} /> : undefined}>
        <Table head={["Season", "M", "Tournaments", "Runs", "HS", "Wkts"]} rows={seasons.map((s) => [s.s, s.m, s.tournaments, IN(s.r), s.hs, s.w])} />
      </Box>
      <Box title="By competition" sub="Batting">
        {comps.length ? (
          <Table head={["Tournament", "League", "Matches", "Runs", "HS", "Avg", "SR", "Wkts"]} left={[1]}
            rows={comps.map((c) => [c.tournament?.tournamentName ?? dash, c.tournament?.leagueName ?? dash, n0(c.matchesPlayed), IN(n0(c.runsScored)), n0(c.highestScore), fx(c.average), fx(c.strikeRate, 1), n0(c.wicketsTaken)])} />
        ) : <p className="acap" style={{ padding: 18 }}>No tournament data yet.</p>}
      </Box>
    </>
  );
};
export default StatsPane;
